export default __webpack_public_path__ + "static/media/logo_blue.a9298b5b.svg";